import React, { Component } from 'react';

class BrandLogos extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { selectedBrand, handleTileClick, brands, ...rest } = this.props;
        const props = {};
        props.className = 'brand-logos brand-logos--modal';

        return (
            <ul {...props} {...rest}>
                {brands.map(brand => {
                    let itemProps = {};
                    let spanProps = {};
                    let sourceProps = {};
                    let imgProps = {};
            
                    itemProps.className = 'brand-logos__item brand-logos__item--modal';
                    spanProps.className = 'brand-logos__logo brand-logos__logo--modal';
                    sourceProps.media = '(max-width: 820px)';
                    sourceProps.srcSet = brand.data['brand-details']['logo-colour'].sizes.logo_240;
                    imgProps.src = brand.data['brand-details']['logo-colour'].sizes.nav_logos;
                    imgProps.alt = `The Brand Logo for ${brand.post_title}`;

                    if (selectedBrand == brand.ID) {
                        itemProps.className += ' brand-logos__item--selected';
                        spanProps.className += ' brand-logos__logo--selected';
                    }

                    return (
                        <li {...itemProps} key={brand.ID}>
                            <span { ...spanProps } onClick={() => {
                                handleTileClick(brand)
                            }}>
                                <picture>
                                    <source { ...sourceProps}/>
                                    <img {...imgProps}/>
                                </picture>
                            </span>
                        </li>
                    )
                 })}
            </ul>
        );
    }
}

export { BrandLogos };